module.exports = __webpack_public_path__ + "img/cca_fr.4115ff29.png";